import { useSelector } from 'react-redux';
import useRematchDispatch from '../../../../hooks/useRematchDispatch';
import type { IRootDispatch, RootState } from '../../../../store/models';

export const useClientNavBarState = () => Object.assign(
  useRematchDispatch((dispatch: IRootDispatch) => ({
    onClientNavBarRendered: dispatch.favorites.onClientNavBarRendered,
    handleCloseHomeBubbleTooltip: dispatch.clientNavBar.closeHomeBubbleTooltip,
  })),
  {
    homeBubbleTooltipProps: useSelector<RootState, RootState['clientNavBar']['homeBubbleTooltipProps']>(
      state => state.clientNavBar.homeBubbleTooltipProps,
      (left, right) => (
        left?.text === right?.text
        && left?.key === right?.key
        && left?.testID === right?.testID
      ),
    ),
    showHomeUnreadBadge: useSelector<RootState, boolean>(
      state => state.clientNavBar.showHomeUnreadBadge,
    ),
  },
);
